export interface SkipToContentProps {
  /** Optional click handler for testing */
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

/**
 * SkipToContent component for keyboard accessibility
 * Provides a skip link that appears on focus to jump to main content
 */
export function SkipToContent({ onClick }: SkipToContentProps = {}) {
  return (
    <a
      href="#main-content"
      onClick={onClick}
      className="bg-primary text-primary-foreground sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[9999] focus:rounded focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:shadow-lg focus:ring-2 focus:ring-offset-2 focus:outline-none"
    >
      Skip to main content
    </a>
  );
}
